import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SuperAdminUserFields from './SuperAdminUserFields'

export const SuperAdminUserCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <SuperAdminUserFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default SuperAdminUserCreate
